<template>
  <transition name="slide">
    <div class="tip-box" :class="this.tipType" v-show="tipShow">
      &ensp;<i class="iconfont" :class="iconCls"></i>&ensp;&ensp;{{ tipWords }}
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      tipWords: this.$t("tipBox.success"), // 默认提示
      tipShow: false,
      timer: null,
      tipType: "success",
    };
  },
  computed: {
    iconCls() {
      switch (this.tipType) {
        case "error":
        case "warning":
          return "icon-jinggao";
        default:
          return "icon-zhengque";
      }
    },
  },
  methods: {
    hide() {
      if (this.tipShow) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.tipShow = false;
        }, 1500);
      }
    },
  },
  mounted() {
    let This = this;
    this.$EventBus.$on("hide", function (data) {
      if (typeof data !== "string") {
        This.tipWords = data.msg;
        This.tipType = data.type;
      } else {
        // 多语言处理
        if (data === "登录成功") {
          This.tipWords = This.$t("tipBox.login_success");
        } else if (data === "操作成功") {
          This.tipWords = This.$t("tipBox.success");
        } else {
          This.tipWords = data;
        }
        This.tipType = "success";
        if (data === "登录成功") {
          location.reload();
        }
      }
      This.tipShow = true;
      This.hide();
    });
  },
};
</script>
<style scoped>
.slide-enter-active {
  transition: all 0.3s linear;
}
.slide-leave-active {
  transition: all 0.3s linear;
}
.slide-enter {
  transform: translateY(-100%);
  opacity: 0;
}
.slide-leave-to {
  transform: translateY(-110%);
  opacity: 0;
}
.tip-box {
  position: fixed;
  z-index: 100;
  top: 2rem;
  min-width: 46rem;
  height: 4.8rem;
  border-radius: 0.5rem;
  background: #c5f8dc;
  padding: 0 1.1rem;
  color: #02735a;
  font-size: 1.4rem;
  line-height: 4.8rem;
  left: 50%;
  margin-left: -23rem;
}
.tip-box.error {
  background-color: #fef0f0;
  color: #f56c6c;
}
.tip-box.warning {
  background-color: #fdf6ec;
  color: #e6a23c;
}
</style>



// WEBPACK FOOTER //
// src/base/tipBox.vue